<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J8VqIB/tc-custom/9781426842696.jpg?1721404315721" alt="This image is the cover for the book Billionaire's Bride of Innocence, Three Rich Husbands"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billionaire's Bride of Innocence, Three Rich Husbands
      </h1>
      <p class="bookDescription body article font2">
        <p>James Logan knew it was time to take a wife and produce an heir. Megan was perfect for his plans: shy, unworldly and quickly seduced by the Sydney advertising tycoon's devilish charm. She was pregnant on their wedding day.<br/><br/>The honeymoon was barely over when Megan had a miscarriage and the scales fell from her eyes: she was trapped in a convenient marriage, and James expected her to conceive again soon. She should have demanded a divorce, but Megan was facing the uncomfortable truth: she'd fallen in love with her ruthless husband….<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miranda Lee
      </h2>
      
      <p class="authorDescription body article">After leaving her convent school, Miranda Lee briefly studied the cello before moving to Sydney, where she embraced the emerging world of computers. Her career as a programmer ended after she married, had three daughters and bought a small acreage in a semi-rural community. She yearned to find a creative career from which she could earn money. When her sister suggested writing romances, it seemed like a good idea. She could do it at home, and it might even be fun! She never looked back.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?244cc431